<template>
  <div class="tab-wrapper">
    <div class="tab-list">
      <ul class="nav nav-tabs">
        <li
          v-for="(tab, index) in tabs"
          :key="index"
          class="nav-item"
          :class="{ 'active': tab.isActive }">
          <a :href="tab.href"
            class="nav-link"
            :class="[tab.tabClass]"
            @click.prevent="selectTab(tab)">
            {{ tab.name }}
          </a>
        </li>
      </ul>
    </div>

    <div class="tab-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',

  data() {
    return {
      tabs: [],
    };
  },

  computed: {
    tabsCount() {
      return this.tabs.length || 0;
    },
  },

  created() {
    this.tabs = this.$children;
  },

  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        tab.isActive = (tab.href === selectedTab.href);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .tab-wrapper {
    .tab-list {
      .nav-tabs {
        display: flex;
        margin: 0;
        padding: 0;
        list-style-type: none;
        border-bottom: 1px solid #ccc;

        .nav-item {
          padding: 0.75rem 1rem;
          border-bottom: 2px solid transparent;

          &.active {
            border-bottom-color: $color-primary;

            .nav-link {
              font-weight: bold;
            }
          }

          .nav-link {
            color: $black;
            line-height: 1;
            font-size: 0.875rem;
            text-transform: uppercase;
          }
        }
      }
    }

    .tab-content {
      margin: 2rem 0;
    }
  }
</style>
